export const noti = {
    text1: "Benachrichtigungen",
    text2: "Liste der Benachrichtigungen.",
    text3: "Sie haben keine Benachrichtigungen",
};